import { render } from "./PdfSelector.vue?vue&type=template&id=4c344704&scoped=true"
import script from "./PdfSelector.vue?vue&type=script&lang=js"
export * from "./PdfSelector.vue?vue&type=script&lang=js"

import "./PdfSelector.vue?vue&type=style&index=0&id=4c344704&lang=scss&scoped=true"

import exportComponent from "/opt/project/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c344704"]])

export default __exports__